// src/constants/specialties.js

// Grouped list for UIs that want buckets (chips/accordions)
export const SPECIALTY_GROUPS = [
  {
    id: "primary_care",
    label: "Primary Care",
    items: [
      { value: "family_medicine", label: "Family Medicine" },
      { value: "general_practitioner", label: "General Practitioner" },
      { value: "internal_medicine", label: "Internal Medicine" },
      { value: "pediatrics", label: "Pediatrics" },
      { value: "obgyn", label: "Obstetrics & Gynecology" },
    ],
  },
  {
    id: "body_systems",
    label: "Body Systems",
    items: [
      { value: "cardiology", label: "Cardiology" },
      { value: "endocrinology", label: "Endocrinology" },
      { value: "gastroenterology", label: "Gastroenterology" },
      { value: "neurology", label: "Neurology" },
      { value: "pulmonology", label: "Pulmonology" },
      { value: "nephrology", label: "Nephrology" },
      { value: "rheumatology", label: "Rheumatology" },
      { value: "dermatology", label: "Dermatology" },
      { value: "allergy_immunology", label: "Allergy & Immunology" },
      { value: "infectious_disease", label: "Infectious Disease" },
    ],
  },
  {
    id: "surgical",
    label: "Surgical Specialties",
    items: [
      { value: "general_surgery", label: "General Surgery" },
      { value: "orthopedics", label: "Orthopedic Surgery" },
      { value: "ent", label: "ENT (Otolaryngology)" },
      { value: "urology", label: "Urology" },
      { value: "ophthalmology", label: "Ophthalmology" },
      { value: "cardiothoracic", label: "Cardiothoracic Surgery" },
      { value: "neurosurgery", label: "Neurosurgery" },
      { value: "plastic_surgery", label: "Plastic & Reconstructive Surgery" },
      { value: "vascular_surgery", label: "Vascular Surgery" },
    ],
  },
  {
    id: "hospital_based",
    label: "Hospital-based",
    items: [
      { value: "anesthesiology", label: "Anesthesiology" },
      { value: "emergency_medicine", label: "Emergency Medicine" },
      { value: "critical_care", label: "Critical Care Medicine" },
      { value: "hospitalist_medicine", label: "Hospitalist Medicine" },
    ],
  },
  {
    id: "diagnostic",
    label: "Diagnostic & Laboratory",
    items: [
      { value: "radiology", label: "Diagnostic Radiology" },
      { value: "interventional_radiology", label: "Interventional Radiology" },
      { value: "pathology", label: "Pathology (Anatomic & Clinical)" },
      { value: "nuclear_medicine", label: "Nuclear Medicine" },
    ],
  },
  {
    id: "mental_health",
    label: "Mental Health",
    items: [
      { value: "psychiatry", label: "Psychiatry" },
      {
        value: "child_adolescent_psychiatry",
        label: "Child & Adolescent Psychiatry",
      },
    ],
  },
  {
    id: "other",
    label: "Other / Cross-cutting",
    items: [
      { value: "occupational_medicine", label: "Occupational Medicine" },
      { value: "preventive_medicine", label: "Preventive Medicine" },
      { value: "public_health_specialist", label: "Public Health Specialist" },
      { value: "sexual_health", label: "Sexual Health" },
      { value: "sports_medicine", label: "Sports Medicine" },
      { value: "palliative_medicine", label: "Palliative Medicine" },
      {
        value: "public_health",
        label: "Public Health & Community Medicine",
      },
    ],
  },
];

// Flattened options with group metadata – perfect for dropdowns / search
export const SPECIALTY_OPTIONS = SPECIALTY_GROUPS.flatMap((group) =>
  group.items.map((item) => ({
    groupId: group.id,
    groupLabel: group.label,
    value: item.value,
    label: item.label,
  })),
);

// Simple flat helper for quick lookups/scoring
export const FLAT_SPECIALTIES = SPECIALTY_OPTIONS.map((o) => o.value);
